import React from 'react';
import { Section } from './ui/Section';
import { UtensilsCrossed, Flame, Wheat } from 'lucide-react';
export function About() {
  return <Section id="about" className="bg-[#FFF8E7]" data-id="element-9">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-10">
        <div className="space-y-6" data-id="element-11">
          <div className="flex items-center space-x-2 text-[#D4735E] mb-2" data-id="element-12">
            <Flame size={24} data-id="element-13" />
            <span className="uppercase tracking-widest text-sm font-bold" data-id="element-14">
              Our Tradition
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl text-[#2C2416] leading-tight" data-id="element-15">
            Forged in Fire, <br data-id="element-16" />
            <span className="text-[#D4735E]" data-id="element-17">Crafted by Hand</span>
          </h2>
          <p className="text-lg text-[#2C2416]/80 leading-relaxed font-serif" data-id="element-18">
            At Duelistarena, we don't just make pizza; we honor a centuries-old
            ritual. Our dough rests for 48 hours, developing a flavor that is
            both complex and comforting. Baked in our wood-fired oven at 450°C,
            each pizza emerges with the perfect "leopard spotting" – the mark of
            true Neapolitan authenticity.
          </p>
          <p className="text-lg text-[#2C2416]/80 leading-relaxed font-serif" data-id="element-19">
            We source our San Marzano tomatoes from the volcanic soils of Mount
            Vesuvius and our buffalo mozzarella from Campania. No shortcuts, no
            compromises.
          </p>

          <div className="pt-6 flex gap-8" data-id="element-20">
            <div className="text-center" data-id="element-21">
              <div className="w-12 h-12 bg-[#D4735E]/10 rounded-full flex items-center justify-center mx-auto mb-3 text-[#D4735E]" data-id="element-22">
                <Wheat size={24} data-id="element-23" />
              </div>
              <span className="font-bold font-serif text-[#2C2416]" data-id="element-24">
                00 Flour
              </span>
            </div>
            <div className="text-center" data-id="element-25">
              <div className="w-12 h-12 bg-[#D4735E]/10 rounded-full flex items-center justify-center mx-auto mb-3 text-[#D4735E]" data-id="element-26">
                <Flame size={24} data-id="element-27" />
              </div>
              <span className="font-bold font-serif text-[#2C2416]" data-id="element-28">
                Wood Fired
              </span>
            </div>
            <div className="text-center" data-id="element-29">
              <div className="w-12 h-12 bg-[#D4735E]/10 rounded-full flex items-center justify-center mx-auto mb-3 text-[#D4735E]" data-id="element-30">
                <UtensilsCrossed size={24} data-id="element-31" />
              </div>
              <span className="font-bold font-serif text-[#2C2416]" data-id="element-32">
                Handmade
              </span>
            </div>
          </div>
        </div>

        <div className="relative" data-id="element-33">
          <div className="absolute inset-0 border-4 border-[#D4735E] transform translate-x-4 translate-y-4 z-0" data-id="element-34" />
          <img src="https://images.unsplash.com/photo-1574126154517-d1e0d89e7344?q=80&w=1980&auto=format&fit=crop" alt="Chef making pizza" className="relative z-10 w-full h-[500px] object-cover shadow-xl grayscale-[20%] sepia-[20%]" data-id="element-35" />
        </div>
      </div>
    </Section>;
}